import React, { createContext, useContext, useState } from 'react';

const AdminContext = createContext();

export const useAdmin = () => {
  const context = useContext(AdminContext);
  if (!context) {
    throw new Error('useAdmin must be used within AdminProvider');
  }
  return context;
};

const parseToken = (token) => {
  if (!token) return null;
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    return payload;
  } catch (e) {
    return null;
  }
};

export const AdminProvider = ({ children }) => {
  const [isAdmin, setIsAdmin] = useState(() => !!localStorage.getItem('adminToken'));

  const getTokenData = () => parseToken(localStorage.getItem('adminToken'));

  const login = (token) => {
    localStorage.setItem('adminToken', token);
    setIsAdmin(true);
  };

  const logout = () => {
    localStorage.removeItem('adminToken');
    setIsAdmin(false);
    window.location.href = '/';
  };

  const getRole = () => {
    const data = getTokenData();
    return data?.role || 'member';
  };

  const getPermissions = () => {
    const data = getTokenData();
    return data?.permissions || {};
  };

  const hasPermission = (permission) => {
    if (getRole() === 'admin') return true; // admin has all
    const perms = getPermissions();
    return !!perms[permission];
  };

  const isAdminRole = () => getRole() === 'admin';

  return (
    <AdminContext.Provider value={{
      isAdmin, setIsAdmin, login, logout,
      getRole, getPermissions, hasPermission, isAdminRole
    }}>
      {children}
    </AdminContext.Provider>
  );
};
